declare global {
    interface Window {
        LocalizationIdentifier: typeof LocalizationIdentifier;
        DomainIdentifier: typeof DomainIdentifier;
        UpdateHeaderLogo: typeof updateHeaderLogo;
        GetCachedResponse: typeof cachedAPIWrapper;
        GetCachedUnifiedSync: typeof getCachedAPIResponse;
        BookingWrapper: typeof bookingUsPostCallWrapper;
        ContactWrapper: typeof contactUsPostCallWrapper;
        PriceQuoteWrapper: typeof priceQuoteWrapper;
        CouponOffersWrapper: typeof couponOffersWrapper;
        IsReturningCustomerWrapper: typeof isReturningCustomerWrapper;
        CalendarInvite: typeof calendarInvite;
        UnlockIt: typeof unlockIt;
        ValidateEmail: typeof validateEmail,
        CalcEstimate: typeof calcEstimate,
        HandleMissingData: typeof handleMissingData
    }
}
import { AreaWeServe, Footer } from "../common";
import { apiConfig } from "../config/apiConfig";
import { apiCaching } from "../config/cachingConfig";
import { isTouchDevice } from "../util/device-detection";
import { DisclaimerServiceIdentifier } from "../util/disclaimerService";
import { DomainIdentifier } from "../util/domainService";
import { updateHeaderLogo } from "../util/headerUpdate";
import { getDisplayPhoneNumber, LocalizationIdentifier } from "../util/localizationService";
import { handleCrossDomainLink, logPayloadForFakeSubmit, updateHeaderContent, getBrandDetailsFromBrandJson, detectFinancingPage } from "../util/share";
import { cachedAPIWrapper, getCachedAPIResponse } from "../apiCaching/apiWrapper";
import { bookingUsPostCallWrapper } from "../apiCaching/POST-Requests/apibookingCallWrapper";
import { contactUsPostCallWrapper } from "../apiCaching/POST-Requests/apiContactCallWrapper";
import { priceQuoteWrapper } from "../apiCaching/POST-Requests/apiPriceQuoteWrapper";
import { couponOffersWrapper } from "../apiCaching/POST-Requests/apiCouponOffersWrapper";
import { isReturningCustomerWrapper } from "../apiCaching/POST-Requests/apiIsReturningCustomerWrapper";
import { localizationTagLine, localizationTagUpadation } from "../util/localizationTag";
import { calendarInvite } from "../util/confirmation-page-add-to-calendar";
import { unlockIt } from "../api/apiLogger";
import { HeaderSwitch } from "../util/headerSwitch";
import { validateEmail } from "../util/real-time-email-validation";
import { LocalizedToken } from "../helperModules/localizedToken";
import { restructureImages } from "../util/imageQuality";
import { EventService } from "../event-service/eventService";
import { getPageSettings } from "../util/pageSettings";
import { attachVersionPrinterToWindow } from "../util/versionControl";
import { calcEstimate } from "../mly/callBookingApi";
import { handleMissingData } from "../util/discovery";


interface LoggedError {
    httpStatusCode?: string;
    message: string;
    stackTrace?: string;
    timeStamp: Date;
    apiEndpoint?: string;
    deviceType?: string;
}
export class OnLoaderServices {

    private static instance: OnLoaderServices;
    private loggedErrors: LoggedError[] = [];

    constructor(phoneNumber: any, fullAttributeData: any) {
        //to get the location from the url
        this.getLocalizedFromLink(fullAttributeData);

        //to capture all error logs
        this.attachErrorListener();

        //replace Phone Numbers
        this.updatePhoneNumbersOnPage(phoneNumber);

        //replace taglines
        this.updateTaglines();

        //display the social media icons for mobile devices
        this.displaySocialMediaIcons();

        //check if the page is a confirmation page and log the payload for fake booking confirmation
        this.printFakeBookingConfirmation();

        //localised Header in national
        this.localisedHeader();

        // Add animation
        this.addAnimation()
        //Check and correct images
        this.photoGalleryImageHelper();

        this.captureUserDetailsFromQuery();

    }

    //Capture Query Parameter ?onemail on Page Load
    captureUserDetailsFromQuery() {
        const params = new URLSearchParams(globalThis.location.search);
        // Check if onemail param exists
        const encodedValue = params.get('onemail');
        if (!encodedValue) return;
        try {
            // Store in localStorage
            sessionStorage.setItem("cs-userDetails", encodedValue);
        } catch (error) {
            console.warn("Error while storing user details from onemail param", error);
            // remove if decoding fails
            sessionStorage.removeItem("cs-userDetails");
        }
    }

    photoGalleryImageHelper() {
        const domElements = document.querySelectorAll('.photo-gallery-section .gallery-wrapper .tns-outer .photo-gallery-list') as NodeListOf<HTMLUListElement>;
        if (domElements?.length === 0) return;
        domElements.forEach(element => {
            if (element) {
                restructureImages(element);
            }
        });
    }

    localisedHeader() {
        HeaderSwitch.getInstance();
    }

    static getInstance(phoneNumber: any, fullAttributeData: any): OnLoaderServices {
        if (!OnLoaderServices.instance) {
            OnLoaderServices.instance = new OnLoaderServices(phoneNumber, fullAttributeData);
        }
        return OnLoaderServices.instance;
    }

    static async getAsyncData() {
        let phoneNumber, fullAttributeData;
        try {
            const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
            const brandData = await getBrandDetailsFromBrandJson(conceptCode);
            sessionStorage.setItem('brandDetails', JSON.stringify(brandData));

            phoneNumber = await getDisplayPhoneNumber();

            const url = window.location.href;
            const urlObj = new URL(url);
            const urlParams = urlObj.searchParams;
            const location = urlParams.get("location");
            if (location) {
                localStorage.setItem('weblocationId', location);
                const url = `${apiConfig.GET_ATTRIBUTE_DATA}/${location}`;
                fullAttributeData = await cachedAPIWrapper(url, apiCaching.FullAttributeResponse);
            }
        } catch (error) {
            console.warn('Error getting the data', error);
        }

        OnLoaderServices.getInstance(phoneNumber, fullAttributeData);
    }


    addAnimation() {
        this.addAnimationToHeaderCTA()
    }
    async addAnimationToHeaderCTA() {
        const conceptCodeElement = (document.getElementById('conceptCode') as HTMLInputElement)
        if (!conceptCodeElement) return;
        const conceptCode = conceptCodeElement.value
        const brandData = await getBrandDetailsFromBrandJson(conceptCode);
        if (!brandData) return;
        const isEnableAnimation: boolean = brandData['enable_animation']
        const allLeadCtaHeaderArray = document.querySelectorAll<HTMLAnchorElement>(".brand-header-mob>.header-cta-mobile>.cta-header-component-lead, .header-cta-container>a.primary-btn, .brand-header-mob .header-cta-mobile .primary-btn.replace-with-click-to-lead-cta");
        if (allLeadCtaHeaderArray.length == 0) return;
        if (isEnableAnimation) {
            allLeadCtaHeaderArray.forEach((anchorElement) => {
                anchorElement.classList.add('animation')
            })
        } else {
            allLeadCtaHeaderArray.forEach((anchorElement) => {
                anchorElement.classList.remove('animation')
            })
        }
    }

    displaySocialMediaIcons() {
        if (isTouchDevice()) {
            const pageScope = getPageSettings('pagescope');
            if (pageScope === 'local') {
                const mainDom = document.querySelector('.header-wrapper .brand-header') as HTMLElement;
                if (!mainDom) return;
                mainDom.style.display = "";
            }
        }
    }

    printFakeBookingConfirmation() {
        const pageScope = getPageSettings('pagetemplate');
        const isConfirmationPage = pageScope?.toLowerCase().includes('confirmation');
        if (isConfirmationPage) {
            logPayloadForFakeSubmit();
        }
    }

    private updatePhoneNumbersOnPage(phoneNumber: any) {
        phoneNumber = phoneNumber ? String(phoneNumber) : null;
        if (!phoneNumber) {
            return;
        }

        const ctaElements = document.querySelectorAll('.sticky-footer-cta') as NodeListOf<HTMLAnchorElement>;
        const phoneTileElements = document.querySelectorAll('.click-to-call:not([target="_self"])') as NodeListOf<HTMLAnchorElement>;

        const stickyTitleElement = document.querySelector('.sticky_title');
        const stickyFooterElement = document.querySelector('.sticky-footer-cta.cta-footer-component-lead');
        if (stickyTitleElement && stickyFooterElement) {
            const phoneNumberText = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
            const stickyTitle = `<svg class="icon sticky_icon"><use xlink:href="/_assets-global/images/hero-icon-sprite.svg#phone-primary"></use></svg>${phoneNumberText}`;
            stickyFooterElement.innerHTML = stickyTitle;
        }

        // Filter out elements with target="_self" to avoid modifying links that open in a new tab
        [...ctaElements, ...phoneTileElements].forEach((linkElement) => {
            if (linkElement) {
                linkElement.href = `tel:${phoneNumber.replace(/[\(\)\-\s]/g, "")}`;
            }
        });
    }

    updateTaglines() {
        localizationTagLine();
    }

    private attachErrorListener(): void {
        window.addEventListener('error', (event) => {
            const error = event.error;
            const timeStamp = new Date(Date.now());
            if (error) {
                const loggedError: LoggedError = {
                    httpStatusCode: error.httpStatusCode ?? "",
                    message: error.message ?? "No message",
                    stackTrace: error.stack ?? "No message",
                    timeStamp,
                    deviceType: isTouchDevice() ? `Mobile Device - UserAgent: ${navigator.userAgent}` : `Desktop Device - UserAgent: ${navigator.userAgent}`
                };
                this.loggedErrors.push(loggedError);
            }
            else {
                const loggedError: LoggedError = {
                    httpStatusCode: "No Status Code, as error is in the script",
                    message: event.message ?? "No Trace available",
                    stackTrace: "No message",
                    timeStamp,
                    deviceType: isTouchDevice() ? `Mobile Device - UserAgent: ${navigator.userAgent}` : `Desktop Device - UserAgent: ${navigator.userAgent}`
                };
                console.info(event.message ?? "Error in GTM script");
                this.loggedErrors.push(loggedError);
            }

        });
    }

    getLoggedErrors(): LoggedError[] {
        return this.loggedErrors;
    }

    private getLocalizedFromLink(data: any) {
        if (data) {
            const conceptId = (document.getElementById('conceptId') as HTMLInputElement)?.value;
            const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
            if (data.conceptId === Number(conceptId) && data.brandCode === conceptCode) {
                this.setLocalData(data, data?.zip);
            }
        }
    }

    //setting hidden input items into the DOM
    updateInputValue(inputId: string, value: string | number | null | undefined) {
        try {
            const hiddenInput = document.getElementById(inputId) as HTMLInputElement | null;

            if (hiddenInput && value !== null && value !== undefined) {
                hiddenInput.value = value.toString();
            }
        } catch (error) {
            console.warn(`Error in updateInputValue function: ${error}`);
        }
    }

    //setting localization
    private async setLocalData(data: any, zipCode: any) {

        if (data) {
            const { franchiseWebLocationId, locationDoingBusinessAs, locationWebsiteUrl, mainPhoneNumber, callTrackings } = data;
            localStorage.setItem("franchiseWebLocationId", franchiseWebLocationId);
            sessionStorage.setItem('franchiseId', franchiseWebLocationId);
            localStorage.setItem('doingBusinessAs', locationDoingBusinessAs);
            sessionStorage.setItem('redirectionURL', locationWebsiteUrl);
            localStorage.setItem('weblocationId', franchiseWebLocationId);
            const locationUrl = locationWebsiteUrl?.replace(/\/$/, '') ?? '';
            const splitUrlArr = locationUrl.toLowerCase().split("/");
            const pathname = splitUrlArr[splitUrlArr.length - 1];

            // Handled the cross domain link for the location URL
            handleCrossDomainLink(locationUrl)

            let callTrackNumber: any = mainPhoneNumber;

            callTrackings.forEach((type: any) => {
                if (type.callTrackingTypeDescription == "WebsiteTracking") {
                    callTrackNumber = type.callTrackingNumber;
                    localStorage.setItem('localPhoneNumber', callTrackNumber);
                }
            });
            const phoneNO: any = document.querySelector('.header-wrapper .form-call-cta')

            if (phoneNO) {
                phoneNO.href = `tel:${callTrackNumber}`
                const reg = /(\d{0,3})(\d{0,3})(\d{0,4})/;
                const phoneFormat: any = String(callTrackNumber)?.replace(/\D/g, '').match(reg);
                phoneNO.innerHTML = `(${phoneFormat[1]}) ${phoneFormat[2]}-${phoneFormat[3]}`;
            }

            const mobile: any = document.querySelector('.header-cta-mobile .primary-btn')

            if (mobile) {
                mobile.href = `tel:${callTrackNumber}`

            }

            if (pathname) {
                localStorage.setItem('dbaName', pathname);
                localizationTagUpadation();
            }
            this.updateInputValue("local_weblocationId", franchiseWebLocationId);
            this.updateInputValue("weblocationId", franchiseWebLocationId);
            this.updateInputValue("full_dbaName", pathname);
            this.updateInputValue("dbaName", pathname);

            const address = document.querySelector('.header-wrapper .address')
            const desc = document.querySelector('.header-wrapper .description')

            if (locationDoingBusinessAs) {
                updateHeaderContent(locationDoingBusinessAs);
            }

            if (address && desc) {
                address.innerHTML = locationDoingBusinessAs
                localizationTagLine();
            }
            const addressEntered: any = (document.getElementById('user-service-address') as HTMLInputElement)?.value;
            sessionStorage.setItem("manualEnteredAddress", addressEntered + ", " + zipCode);
            sessionStorage.setItem("RL_Weblocation_ID", franchiseWebLocationId);
            sessionStorage.setItem("RL_DBAName", locationDoingBusinessAs);
            const globalBrandLogo = document.querySelector(".brand-header .brand-logo-wrapper") as HTMLElement;
            const globalfindLocal = document.querySelector(".brand-header .find-local") as HTMLElement;
            if (globalBrandLogo) {
                globalBrandLogo.style.display = "none";
            }
            if (globalfindLocal) {
                globalfindLocal.style.display = "none";
            }
            Footer.init();
        }
    }
}

(async () => {
    document.addEventListener("DOMContentLoaded", async () => {
        await OnLoaderServices.getAsyncData();
        const sAddressParam = sessionStorage.getItem('sAddressParam');
        DisclaimerServiceIdentifier(sAddressParam);

        const headerLogoURL = localStorage.getItem("localHeaderUrl");
        const headerLogoAlt = localStorage.getItem("localHeaderAlt");
        if (headerLogoURL) {
            updateHeaderLogo(headerLogoURL, headerLogoAlt ?? "Brand Logo");
        }

        const webId: string | null = localStorage.getItem('weblocationId');
        const dbaName = localStorage.getItem('dbaName');
        const serviceLargeMediaTile = (document.getElementById('servicelargemediatile') as HTMLInputElement)?.value;
        const replacementBlockDynamicTile = (document.getElementById('replacementblockdynamic') as HTMLInputElement)?.value;

        if (webId && dbaName && !(serviceLargeMediaTile || replacementBlockDynamicTile)) {
            LocalizedToken.getInstance();
        }

        //for text to speech;
        conditionalAttachTextToSpeech().then(() => {
            console.log("Initalized")
        }).catch((error) => {
            console.warn("Failed to load the text to speech Module", error);
        });
        //Text to speech ends here

        window.LocalizationIdentifier = LocalizationIdentifier;
        window.DomainIdentifier = DomainIdentifier;
        window.UpdateHeaderLogo = updateHeaderLogo;
        window.GetCachedResponse = cachedAPIWrapper;
        window.GetCachedUnifiedSync = getCachedAPIResponse;
        window.BookingWrapper = bookingUsPostCallWrapper;
        window.ContactWrapper = contactUsPostCallWrapper;
        window.PriceQuoteWrapper = priceQuoteWrapper;
        window.CouponOffersWrapper = couponOffersWrapper;
        window.IsReturningCustomerWrapper = isReturningCustomerWrapper;
        window.CalendarInvite = calendarInvite;
        window.UnlockIt = unlockIt;
        window.ValidateEmail = validateEmail;
        window.CalcEstimate = calcEstimate;
        window.HandleMissingData = handleMissingData;
        // Call AreaWeServe.create() for async initialization
        await AreaWeServe.create();
        // Call EventService.create()
        await EventService.create();
        detectFinancingPage();
    });
})();

export async function conditionalAttachTextToSpeech(): Promise<string | boolean> {
    try {
        const pageTemplate = getPageSettings('pagetemplate');
        const externalConfig = await determineIfT2SpeechShouldBeEnabledFromConfig();
        if (!pageTemplate?.toLowerCase().includes('opus 2 blog article details') || !("speechSynthesis" in window) || !externalConfig)
            //reject promise;
            return Promise.reject(new Error("TextToSpeech - Page Template does not match or SpeechSynthesis API is not supported"));
        const { TextToSpeechHelper } = await import(/* webpackChunkName: "textToSpeech" */ '../text2speech/mainT2S');
        await TextToSpeechHelper.create();

        return Promise.resolve(true);
    }
    catch (error) {
        console.warn("Failed to load the text to speech Module", error);
        return Promise.reject(error);
    }
}

export async function determineIfT2SpeechShouldBeEnabledFromConfig() {
    try {
        if (process.env.USE_T2S?.toLowerCase() === 'false')
            return Promise.reject(new Error("TextToSpeech - Disabed from Config Level"));
        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        const brandData = await getBrandDetailsFromBrandJson(conceptCode);
        if (!brandData?.text_to_speech || brandData?.text_to_speech?.toLowerCase() === 'disabled') {
            return Promise.reject(new Error("TextToSpeech - Disabed from Brand JSON Level"));
        }
        return Promise.resolve(true);
    }
    catch (error) {
        console.warn("Failed to load the config for text to speech Module", error);
        return Promise.reject(error);
    }
}

window.addEventListener('load', () => {
    if ('requestIdleCallback' in window) {
        requestIdleCallback(() => {
            setTimeout(() => {
                attachVersionPrinterToWindow();
            }, 50);
        });
    } else {
        setTimeout(() => {
            attachVersionPrinterToWindow();
        }, 1000);
    }
});

